var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../layout.njk"] = require( "../layout.njk" );




var shim = require("D:/workspace/indivior-listmypractice-release/frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/views/pages/index.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../layout.njk", true, "src/views/pages/index.njk", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_title"))(env, context, frame, runtime, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
output += t_4;
output += "\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("meta_description"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("body_class"))(env, context, frame, runtime, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
output += t_8;
output += "\r\n\r\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
output += t_10;
output += "\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_title(env, context, frame, runtime, cb) {
var lineno = 2;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "List My Practice | For Healthcare Providers";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_meta_description(env, context, frame, runtime, cb) {
var lineno = 3;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "List your practice for use in the Indivior Find a SUBLOCADE® (buprenorphine extended-release) Treatment Provider Tool.";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_body_class(env, context, frame, runtime, cb) {
var lineno = 5;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "home";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 7;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "\r\n    <main id=\"main-content\">\r\n        <section>\r\n            <div class=\"container\">\r\n                <h1 class=\"mt-0\">List Your Practice to Help Patients Find&nbsp;Access to Treatment</h1>\r\n                <div class=\"fastp__intro\">\r\n                    <div class=\"intro__content\">\r\n                        <p>\r\n                            The Find a SUBLOCADE Treatment Provider Tool is available to assist patients with moderate to severe opioid use disorder find access to treatment and continuity of care. This free tool helps patients find physicians, nurse practitioners, and physician assistants who treat opioid dependence, have prescribed SUBLOCADE<sup>&reg;</sup> (buprenorphine extended-release) at least once in the previous two years, and have agreed to be listed on the Indivior Find a SUBLOCADE Treatment Provider Tool. \r\n                        </p>\r\n                        <p>\r\n                            Healthcare providers who meet the <a href=\"/terms-of-conditions\">Terms and Conditions</a> may register to be listed or access their account to manage their listing.\r\n                        </p>\r\n                    </div>\r\n                        <div class=\"intro__image\">\r\n                            <img alt=\"\" src=\"/assets/img/shared/tool-callout.jpg\" />\r\n                        </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"container mt-50\">\r\n                <div class=\"fastp__disclaimer\">\r\n                    <p><b>Inclusion on this tool means that provider names and practice locations will be searchable via ZIP code by patients or caregivers looking for SUBLOCADE treatment providers while they are using the INSUPPORT<sup>&reg;</sup> or Indivior brand websites.</b></p>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"container mt-50\">\r\n                <div class=\"fastp__callouts\">\r\n                    <div class=\"callout sign-up\">\r\n                        <p><b>Interested in being listed?</b></p>\r\n                        <a href=\"/register-to-be-listed\" class=\"btn btn-primary\"><span class=\"btn-content\">Register to Be Listed</span></a>\r\n                    </div>\r\n                    <div class=\"callout sign-in\">\r\n                        <p><b>Already listed?</b></p>\r\n                        <a href=\"/access-your-listing\" class=\"btn btn-primary\"><span class=\"btn-content\">Manage Your Listings</span></a>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"container mt-50\">\r\n                <h2>Have Questions?</h2>\r\n                <p>Review the full <a href=\"/terms-of-conditions\">Terms and Conditions</a> for eligibility requirements and answers to the most <a href=\"/faqs\">Frequently Asked Questions</a>.</p>\r\n            </div>\r\n        </section>\r\n    </main>\r\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_meta_title: b_meta_title,
b_meta_description: b_meta_description,
b_body_class: b_body_class,
b_content: b_content,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/views/pages/index.njk"] , dependencies)